module.exports = __webpack_public_path__ + "static/media/p6ru.c9c80d04.pdf";